// extracted by mini-css-extract-plugin
module.exports =  {"root":"OGjrHa","text":"nEoFgW"};